import { Container, Stack, Tag, Typography } from '@optimus-web/core';
import { lt, useFeatureFlag } from '@mews/framework';
import { UnicodeEntity } from '@mews/enums';
import { FeatureFlag } from '@mews-commander/enums';
import { AssistantSearchType, SearchType } from '../../assistantSearchTypes';
import { ThinDivider } from '../styles';
import { AssistantSearchListItemProps } from '../hooks/useAssistantSearchResultListMap';
import { StackWithTransition } from './styles';

interface FooterProps {
    openSummary: boolean;
    hoveredResultType?: AssistantSearchType | undefined;
    selectedItem?: AssistantSearchListItemProps | undefined;
}

const Footer = ({ openSummary, selectedItem }: FooterProps) => {
    const showPreview = selectedItem?.searchType === SearchType.Customer && !openSummary;
    const assistantSummaryEnabled = useFeatureFlag(FeatureFlag.assistantSummaryEnabled);
    return (
        <footer>
            <ThinDivider />
            <Container padding={['100', '200']}>
                <Stack alignment="end" spacing="200" itemAlignment="center">
                    {assistantSummaryEnabled && (
                        <>
                            {showPreview && (
                                <StackWithTransition spacing="50" itemAlignment="center">
                                    <Tag variant="basicSubtle">{UnicodeEntity.ArrowLeft}</Tag>
                                    <Typography textStyle="bodySmall" variant="tertiary" as="div">
                                        {lt('Preview')}
                                    </Typography>
                                </StackWithTransition>
                            )}

                            {openSummary && (
                                <StackWithTransition spacing="50" itemAlignment="center">
                                    <Tag variant="basicSubtle">{UnicodeEntity.ArrowRight}</Tag>
                                    <Typography textStyle="bodySmall" variant="tertiary" as="div">
                                        {lt('HidePreview')}
                                    </Typography>
                                </StackWithTransition>
                            )}
                        </>
                    )}

                    <Stack spacing="50" itemAlignment="center">
                        <Tag variant="basicSubtle">{UnicodeEntity.ArrowUp}</Tag>
                        <Tag variant="basicSubtle">{UnicodeEntity.ArrowDown}</Tag>
                        <Typography textStyle="bodySmall" variant="tertiary" as="div">
                            {lt('Navigate')}
                        </Typography>
                    </Stack>
                    <Stack spacing="50" itemAlignment="center">
                        <Tag variant="basicSubtle">{UnicodeEntity.Enter}</Tag>
                        <Typography textStyle="bodySmall" variant="tertiary" as="div">
                            {lt('Select')}
                        </Typography>
                    </Stack>
                    <Stack spacing="50" itemAlignment="center">
                        <Tag variant="basicSubtle">Esc</Tag>
                        <Typography textStyle="bodySmall" variant="tertiary" as="div">
                            {lt('Close')}
                        </Typography>
                    </Stack>
                </Stack>
            </Container>
        </footer>
    );
};

export default Footer;
